import { render, staticRenderFns } from "./UndocumentedReports.vue?vue&type=template&id=0476dfa0&scoped=true"
import script from "./UndocumentedReports.vue?vue&type=script&lang=js"
export * from "./UndocumentedReports.vue?vue&type=script&lang=js"
import style0 from "./UndocumentedReports.vue?vue&type=style&index=0&id=0476dfa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0476dfa0",
  null
  
)

export default component.exports